import { render, staticRenderFns } from "./MainTabBar.vue?vue&type=template&id=3afde470&scoped=true&"
import script from "./MainTabBar.vue?vue&type=script&lang=js&"
export * from "./MainTabBar.vue?vue&type=script&lang=js&"
import style0 from "./MainTabBar.vue?vue&type=style&index=0&id=3afde470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afde470",
  null
  
)

export default component.exports